import { render, staticRenderFns } from "./ModalsHeader.vue?vue&type=template&id=6d68a5c1"
import script from "./ModalsHeader.vue?vue&type=script&lang=js"
export * from "./ModalsHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports